/* Erzeugt von build.ps1 - nicht von Hand aendern. Quelle: spann-werkstatt/ */
/* RUWI Hubtisch in 3D · Weg "Hubtisch" · Ablauf (r72, Neubau als App-Logik)
   Ersetzt seit 16.09.2026 den Hubtisch-Demonstrator. Seit r72 dieselbe Form wie der geführte Weg r70: vier Bildschirme —
   Größe, Tisch, Fläche, Preis —, ein Knopf „Weiter", nichts scrollt von selbst. Die Schleife „Tisch fährt auf und ab" aus
   Kapitel 0 ist raus: jetzt fährt der Tisch auf die Antwort auf „Wie groß bist du?".
   Spricht nur ueber window.SPANN_API mit dem Motor (WEGE.md).
   Im Theme das Asset ruwi-hubtisch-3d.js (build.ps1), geladen nach ruwi-spannen.js. */
(function () {
  "use strict";
  var API = window.SPANN_API;
  var $ = function (id) { return document.getElementById(id); };
  var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function zahl(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function eur(cent) { var s = (cent / 100).toFixed(2).split('.'); return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1] + ' €'; }
  // von: woher der Besuch kommt, etwa ?von=werkstattberater vom Knopf „In 3D ansehen" (r63). Geht in jedes Ereignis.
  var VON = ''; try { VON = (new URLSearchParams(location.search).get('von') || '').replace(/[^a-z0-9-]/gi, '').slice(0, 40); } catch (e) {}
  // r85: jedes Ereignis trägt Weg, Herkunft und den gewählten Tisch mit; das Ziel Weg:Kapitel reicht dann für den ganzen Trichter (siehe weg-gefuehrt.js).
  function messen(ev, props) {
    try {
      if (!window.plausible) return;
      var p = Object.assign({ weg: 'hubtisch' }, VON ? { von: VON } : {});
      if (typeof gewaehlt === 'string' && gewaehlt) p.tisch = gewaehlt;
      window.plausible(ev, { props: Object.assign(p, props || {}) });
    } catch (e) {}
  }
  var KAPITEL = ['0 Start', '1 Tisch', '2 Fläche', '3 Preis'];
  if (!API || !API.tische) { $('ladeText').textContent = 'Die räumliche Ansicht läuft auf diesem Gerät nicht.'; return; }
  API.herkunft('hubtisch');
  var NEIGUNG_ROT = 60;

  // r79: Abstand der App vom Seitenanfang, nicht nur die Höhe der Kopfzeile. Über dem Header stehen auf ruwi.de die Ankündigungsleiste
  // und die Social-Zeile (live 71 px); am Desktop lag „Weiter" um so viel unter dem Rand. CSS --ruwi-kopf.
  function kopfMessen() { var a = document.querySelector('.ruwi-hub3d .app'), k = document.querySelector('.ruwi-hub3d'); if (!a || !k) return; k.style.setProperty('--ruwi-kopf', Math.max(0, Math.round(a.getBoundingClientRect().top + window.pageYOffset)) + 'px'); }
  kopfMessen(); window.addEventListener('load', kopfMessen); window.addEventListener('resize', kopfMessen);

  /* Shop-Adressen der vier Tische, aus dem Schema der Collection /collections/hubtisch (Livetest 08.09.2026).
     Der Preis kommt live aus /products/<handle>.js; ohne Shop (lokal, Artifact) steht keine Zahl da. */
  var HANDLE = { basic: 'hubtisch-basic', classic: 'hubtisch-classic', premium: 'hubtisch-premium', classicxl: 'hubtisch-classic-300xl' };
  var TISCHE = API.tische(), NACH = {};
  TISCHE.forEach(function (t) { NACH[t.k] = t; });
  // ?modell= aus Links auf den alten Demonstrator gilt wie ?tisch= (dieselben Schlüssel).
  try { var qm = new URLSearchParams(location.search).get('modell'); if (qm && NACH[qm] && !new URLSearchParams(location.search).get('tisch')) API.tisch(qm); } catch (e) {}
  var gewaehlt = NACH[API.zustand().tisch] ? API.zustand().tisch : 'premium';

  function kurz(t) { return t.n.replace('RUWI Hubtisch ', ''); }
  function mass(a) { return zahl(a[0]) + ' × ' + zahl(a[1]) + ' mm'; }

  // Kacheln
  var tischeEl = $('tische');
  TISCHE.forEach(function (t) {
    var b = document.createElement('button'); b.type = 'button'; b.className = 'tisch'; b.dataset.k = t.k; b.setAttribute('aria-pressed', 'false');
    b.innerHTML = '<b></b><span class="f"></span><br><span class="h"></span>';
    b.querySelector('b').textContent = kurz(t);
    b.querySelector('.f').textContent = mass(t.flaeche) + (t.ausgezogen ? ', bis ' + zahl(t.ausgezogen) : '');
    b.querySelector('.h').textContent = 'Höhe ' + zahl(t.hub[0]) + ' bis ' + zahl(t.hub[1]) + ' mm';
    b.addEventListener('click', function () { waehlen(t.k); messen('Weg:Tisch', { tisch: t.k }); });
    tischeEl.appendChild(b);
  });
  function waehlen(k) {
    gewaehlt = k; API.tisch(k); API.auszug(false);
    texte(); kamera();
  }

  // Bildschirm 1 zeigt die Höhe. Basic und Classic fahren im Modell nicht, dort übernimmt der Premium (Motor).
  // Verlässt man die Höhe, steht wieder der gewählte Tisch da.
  function tischZurueck() { if (API.zustand().tisch !== gewaehlt) API.tisch(gewaehlt); }

  function hoeheEinst(z) { return { theta: (z.figurSeite > 0 ? Math.PI : 0) + 0.95, phi: 1.32, dist: 3.35, y: 0.86, x: (z.figurX || 0) / 2 + 0.3 }; } // + 0,3 m: das Maßband rechts neben dem Tisch samt Beschriftung im Bild
  var EINST = window.WEG_EINST = { // window: werkzeug/poster-rendern.js rendert mit derselben Einstellung wie Bildschirm 1
    0: hoeheEinst,
    1: function () { var w = NACH[gewaehlt].flaeche[0] / 1000; return { theta: 0.62, phi: 1.2, dist: Math.max(2.6, w * 1.75), y: 0.55 }; },
    // Von vorn schräg oben, weit genug für den ausgezogenen XL (2,7 m) auch im Hochformat.
    2: function (z) { var t = NACH[gewaehlt], w = (z.auszug && t.ausgezogen ? t.ausgezogen : t.flaeche[0]) / 1000; return { theta: 0.55, phi: 0.92, dist: Math.max(3.2, w * 2.2), y: (z.hoeheMM != null ? z.hoeheMM : 900) / 1000 - 0.1 }; },
    3: function () { var w = NACH[gewaehlt].flaeche[0] / 1000; return { theta: -0.6, phi: 1.12, dist: Math.max(2.6, w * 1.75), y: 0.6 }; }
  };
  var TITEL = ['Wie groß bist du?', 'Welcher Tisch?', 'Deine Fläche.', 'Dein Tisch.'];

  var schritt = 0, mit3d = false, ohne3d = false, freiAn = false, gemessen = {}, t0 = Date.now();
  var schritte = Array.prototype.slice.call(document.querySelectorAll('.schritt'));

  /* Bildschirm wechseln. Jeder Wechsel ist ein Eintrag im Verlauf, damit die Zurück-Geste des Handys einen Schritt
     zurückgeht statt die Seite zu verlassen. */
  function zeige(n, ausVerlauf) {
    n = Math.max(0, Math.min(3, n));
    schritt = n;
    schritte.forEach(function (s) { s.hidden = +s.dataset.schritt !== n; });
    Array.prototype.forEach.call($('punkte4').children, function (i, k) { i.classList.toggle('an', k <= n); });
    $('zurueck').hidden = n === 0; $('weiter').hidden = n === 3;
    $('weiter').textContent = n === 2 ? 'Zum Preis →' : 'Weiter →';
    $('ansage').textContent = TITEL[n] + ' Schritt ' + (n + 1) + ' von 4.';
    if (!ausVerlauf) { try { history.pushState({ schritt: n }, ''); } catch (e) {} }
    if (!gemessen[n]) { gemessen[n] = true; messen('Weg:Kapitel', { kapitel: KAPITEL[n] || String(n) }); }
    texte();
    if (mit3d) {
      if (n === 0) API.ansicht('hoehe');
      else { API.ansicht('spannen'); tischZurueck(); }
      if (n !== 2) API.auszug(false);
      // r62, aus dem alten Demonstrator: Maßband, solange es um die Höhe geht; Bemaßung, wenn es um die Fläche geht.
      API.massband(n === 0); API.masse(n === 2);
      kamera();
    }
    $('anzeigeL').classList.toggle('versteckt', !(n === 0 || n === 2));
    $('anzeigeR').classList.toggle('versteckt', n !== 0);
    $('buehne').classList.toggle('anzeigen', n === 0 || n === 2); // r68: Band über dem Bild am Handy
    window.scrollTo({ top: 0, behavior: rm ? 'auto' : 'smooth' });
  }
  function kamera() { setTimeout(function () { if (mit3d && !freiAn && !(schritt === 0 && auftaktLaeuft)) API.kamera(EINST[schritt](API.zustand())); }, 40); }

  /* r74 · Auftakt (Otto 18.09.: der gebückte Schreiner war kein guter erster Eindruck). Der Tisch steht von Anfang an auf
     der Regelhöhe für 1,78 m, der Schreiner arbeitet aufrecht. Das erste Bild ist eine Totale schräg von oben; in 2,6 s
     gleitet die Kamera auf den Schreiner zu. Das Posterbild zeigt dieselbe Totale (window.WEG_START, gelesen von
     werkzeug/poster-rendern.js), beim Laden springt also nichts. Bei reduzierter Bewegung steht gleich das Endbild. */
  var auftaktLaeuft = false;
  var START = window.WEG_START = function (z) { var e = EINST[0](z); return { theta: e.theta - 0.8, phi: e.phi - 0.24, dist: e.dist * 1.5, y: e.y - 0.05, x: (e.x || 0) * 0.5 }; };
  function auftakt() {
    if (rm) return kamera();
    var beginn = Date.now(), dauer = 2600; auftaktLaeuft = true; handDreh = false;
    API.kamera(START(API.zustand()), true); // hart in die Totale: der Wechsel in die Arbeitshöhe hat die Kamera eben nah gesetzt
    (function bild() {
      if (schritt !== 0 || freiAn || handDreh) { auftaktLaeuft = false; return; }
      var z = API.zustand(), a = START(z), e = EINST[0](z), p = Math.min(1, (Date.now() - beginn) / dauer);
      var q = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2, mix = {};
      ['theta', 'phi', 'dist', 'y', 'x'].forEach(function (k) { mix[k] = a[k] + ((e[k] || 0) - a[k]) * q; });
      API.kamera(mix);
      if (p < 1) setTimeout(bild, 40); else auftaktLaeuft = false;
    })();
  }
  // Schon beim Laden in die Totale: bis das Modell steht, hat die Kamera sie hinter dem Poster erreicht.
  if (!rm) API.kamera(START(API.zustand()), true);
  /* r79 · Am Desktop dreht man direkt im Bild (Otto: ohne zweiten Klick; am Handy bleibt das Bild ruhig, dort scrollt der Finger).
     Freigegeben per CSS für Maus-Geräte ab 900 px. Der Motor übernimmt den gedrehten Winkel in die Regie. Ziehen hält den Auftakt
     an; ein Klick, dem ein Zug vorausging, ist kein Tipp aufs Bild. */
  var handDreh = false, zugWeg = 0, zugX = 0, zugY = 0;
  $('ruwi-sp-view').addEventListener('pointerdown', function (e) { handDreh = true; auftaktLaeuft = false; zugWeg = 0; zugX = e.clientX; zugY = e.clientY; });
  $('ruwi-sp-view').addEventListener('pointermove', function (e) {
    if (!e.buttons) return;
    zugWeg += Math.abs(e.clientX - zugX) + Math.abs(e.clientY - zugY); zugX = e.clientX; zugY = e.clientY;
    if (zugWeg > 6 && $('drehhinweis')) $('drehhinweis').classList.add('weg');
  });
  // Der erste Satz nennt die Zahl im Bild und fragt nach der eigenen Größe.
  function satzStart() {
    var z = API.zustand();
    if (z.hoeheMM != null) $('satz0').textContent = 'Der Tisch steht auf ' + zahl(z.hoeheMM) + ' mm, passend für ' + (z.koerper / 100).toFixed(2).replace('.', ',') + ' m. Und für dich?';
  }
  $('weiter').addEventListener('click', function () { zeige(schritt + 1); });
  $('zurueck').addEventListener('click', function () { zeige(schritt - 1); });
  window.addEventListener('popstate', function (e) {
    if (freiAn) { frei(false, true); return; }
    zeige(e.state && e.state.schritt != null ? e.state.schritt : 0, true);
  });

  // Alles, was ohne 3D stimmt.
  function texte() {
    var t = NACH[gewaehlt], z = API.zustand();
    Array.prototype.forEach.call(tischeEl.children, function (c) { var an = c.dataset.k === gewaehlt; c.classList.toggle('an', an); c.setAttribute('aria-pressed', an ? 'true' : 'false'); });
    var satz1 = {
      basic: 'Der Einstieg: feste Platte 1.200 × 800 mm, kein Auszug, dafür der klarste Preis.',
      classic: 'Die Platte wächst mit dem Werkstück: zwei Auszüge machen aus 1.600 mm Länge 2.200 mm. Unter der Platte eine Schublade.',
      premium: 'Zwei Platten übereinander: eine klappt zur Seite und macht aus 1.200 × 800 mm eine Fläche von 1.600 × 1.200 mm.',
      classicxl: 'Der große: 2.000 × 1.000 mm, mit Auszügen 2.700 mm lang.'
    };
    $('satz1').textContent = satz1[gewaehlt] + ' ' + t.bohrungen + ' Bohrungen Ø 20 mm im ' + zahl(t.raster) + 'er Raster.';

    // Bildschirm 1, hinter „Warum?": die Faustregel für diese Größe, und welcher Tisch im Bild fährt.
    var f = z.faustregel;
    if (f) {
      var roh = f.roh, drin = roh >= t.hub[0] && roh <= t.hub[1];
      $('satz2').textContent = 'Leichte Arbeit an der Platte: Oberkante ' + zahl(-f.off / 10) + ' cm unter dem Ellbogen. Bei ' + z.koerper + ' cm sind das ' + zahl(Math.round(roh / 5) * 5) + ' mm' +
        (drin ? ' — der ' + kurz(t) + ' fährt von ' + zahl(t.hub[0]) + ' bis ' + zahl(t.hub[1]) + ' mm, das liegt darin.'
              : ' — der ' + kurz(t) + ' fährt ' + (roh < t.hub[0] ? 'nur bis ' + zahl(t.hub[0]) + ' mm herunter.' : 'nur bis ' + zahl(t.hub[1]) + ' mm hoch.'));
    }
    var gezeigt = NACH[z.tisch] || t;
    $('satzGezeigt').textContent = (!t.faehrt && t.hubNach)
      ? 'Gezeigt am ' + kurz(NACH[t.hubNach] || gezeigt) + ': beim ' + kurz(t) + ' ist das Untergestell in der CAD-Datei ein einziger Körper, die Schere bewegt sich dort nicht. Sein Hub steht in den Stammdaten.'
      : '';

    // Bildschirm 3
    var zeilen = [['Grundfläche', mass(t.flaeche)]];
    if (t.ausgezogen) zeilen.push(['Ausgezogen', zahl(t.ausgezogen) + ' × ' + zahl(t.flaeche[1]) + ' mm']);
    if (gewaehlt === 'premium') zeilen.push(['Aufgeklappt', '1.600 × 1.200 mm']);
    zeilen.push(['Bohrungen', t.bohrungen + ' × Ø 20 mm, Raster ' + zahl(t.raster) + ' mm']);
    $('fakten3').innerHTML = zeilen.map(function () { return '<div class="fakt"><span></span><b></b></div>'; }).join('');
    Array.prototype.forEach.call($('fakten3').children, function (d, i) { d.querySelector('span').textContent = zeilen[i][0]; d.querySelector('b').textContent = zeilen[i][1]; });
    $('auszug').hidden = !t.ausgezogen || !mit3d;
    $('auszug').textContent = z.auszug ? 'Auszüge einschieben' : 'Auszüge ausziehen';
    $('auszug').setAttribute('aria-pressed', z.auszug ? 'true' : 'false');
    $('satz3').textContent = {
      basic: 'Feste Platte, kein Auszug. Mehr Fläche bringen der Classic mit Auszügen oder der Premium mit Schwenkplatte.',
      classic: 'Die Auszüge klemmen stufenlos. Bei 260 der 300 mm stehen ihre Löcher wieder genau im 96er Raster.',
      premium: 'Die Schwenkplatte klappt im Modell noch nicht: das Scharnier ist in der CAD-Datei nicht gezeichnet. Die Fläche steht so im Produkttext.',
      classicxl: 'Die Auszüge laufen auf je zwei Schienen. Aus 2.000 werden 2.700 mm, so steht es in den Stammdaten.'
    }[gewaehlt];

    // Bildschirm 4
    $('titel4').textContent = t.n;
    $('shop').href = '/collections/hubtisch/products/' + HANDLE[gewaehlt];
    // r83: von= als Wort, der Tisch als Link in sw= — die Section ruwi-spannen-gespraech auf der Zielseite zeigt ihn und schreibt ihn in die Anfrage.
    $('gespraech').href = '/pages/werkstattgesprach?von=hubtisch-3d&sw=' + encodeURIComponent('/pages/hubtisch-3d?tisch=' + gewaehlt) + kampagne() + '#anfrage'; // r87: Anker, sonst steht oben der Berater
    preisHolen(gewaehlt);
  }

  // Live-Preis: nur, wenn der Shop antwortet. Kein Preis aus dem Gedächtnis.
  var preise = {};
  function preisZeigen() {
    var p = preise[gewaehlt];
    $('preis').textContent = p ? eur(p) : '';
    $('preisText').textContent = p ? 'inkl. MwSt., zzgl. Versand' : 'Preis und Lieferzeit im Shop';
  }
  function preisHolen(k) {
    if (preise[k] !== undefined) return preisZeigen();
    preise[k] = null; preisZeigen();
    try {
      fetch('/products/' + HANDLE[k] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (j && j.price > 0) { preise[k] = j.price; preisZeigen(); } })
        .catch(function () {});
    } catch (e) {}
  }

  function kampagne() {
    var aus = [];
    try { var q = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'].forEach(function (k) { var v = q.get(k); if (v) aus.push(k + '=' + encodeURIComponent(v)); });
    } catch (e) {}
    return aus.length ? '&' + aus.join('&') : '';
  }

  /* Bildschirm 1: „Wie groß bist du?" Der Tisch steht zu Beginn ganz unten, der Schreiner gebeugt. Beim Ziehen läuft nur
     die Zahl mit; beim Loslassen fährt der Tisch auf die Höhe für diese Größe (wie der geführte Weg r69). */
  var koerperRegler = $('koerperRegler');
  koerperRegler.addEventListener('input', function (e) {
    $('koerperWert').textContent = e.target.value + ' cm';
    e.target.setAttribute('aria-valuetext', e.target.value + ' Zentimeter');
  });
  koerperRegler.addEventListener('change', function (e) {
    API.koerper(+e.target.value, true); texte();
    var z = API.zustand(), g = NACH[z.tisch];
    $('satz0').textContent = 'Der ' + (g ? kurz(g) : 'Hubtisch') + ' fährt auf ' + zahl(z.faustregel.mm) + ' mm.';
    messen('Weg:Körper', { cm: +e.target.value });
  });
  $('auszug').addEventListener('click', function () {
    var auf = !API.zustand().auszug; API.auszug(auf); texte(); kamera();
    messen('Weg:Auszug', { tisch: gewaehlt, offen: auf });
  });
  $('shop').addEventListener('click', function () { messen('Weg:Shop', { tisch: gewaehlt }); });
  $('gespraech').addEventListener('click', function () { messen('Weg:Gespräch', { tisch: gewaehlt }); });

  // Frei ansehen (nur am Desktop sichtbar): Vollbild, eigener Verlaufseintrag, damit die Zurück-Geste es schließt.
  function frei(an, ausVerlauf) {
    if (an === freiAn) return;
    freiAn = an; var b = $('buehne');
    b.classList.toggle('frei', an);
    if (an) { b.setAttribute('role', 'dialog'); b.setAttribute('aria-modal', 'true'); b.setAttribute('aria-label', 'Hubtisch frei drehen'); }
    else { b.removeAttribute('role'); b.removeAttribute('aria-modal'); b.setAttribute('aria-label', '3D-Ansicht'); }
    document.documentElement.style.overflow = an ? 'hidden' : '';
    if (an && !ausVerlauf) { try { history.pushState({ frei: 1, schritt: schritt }, ''); } catch (e) {} }
    API.kamera(an ? null : EINST[schritt](API.zustand()));
    window.dispatchEvent(new Event('resize'));
    (an ? $('zu') : $('frei')).focus();
    if (an) messen('Weg:Frei');
  }
  $('frei').addEventListener('click', function () { frei(true); });
  function schliessen() { if (history.state && history.state.frei) history.back(); else frei(false, true); }
  $('zu').addEventListener('click', schliessen);
  document.addEventListener('keydown', function (e) {
    if (!freiAn) return;
    if (e.key === 'Escape') schliessen();
    if (e.key === 'Tab') { e.preventDefault(); $('zu').focus(); }
  });

  // Ohne 3D: Poster bleibt, Anzeigen weg, die vier Bildschirme funktionieren als Text.
  function ohneDrei(satz) {
    ohne3d = true; $('ladeText').textContent = satz; $('laden').classList.add('ausfall');
    ['anzeigeL', 'anzeigeR', 'frei'].forEach(function (id) { $(id).hidden = true; });
    koerperRegler.closest('.regler').hidden = true;
    $('satz0').textContent = 'Ein Hubtisch fährt die Arbeit auf deine Höhe. Der Premium fährt von 570 bis 1.170 mm.';
    zeige(schritt, true);
  }

  var letzte = 0;
  function takt(t) {
    requestAnimationFrame(takt);
    if (!mit3d && !ohne3d) {
      var st = API.status();
      if (st === 'bereit') {
        mit3d = true; $('laden').classList.add('weg');
        koerperRegler.disabled = false;
        zeige(0, true); try { history.replaceState({ schritt: 0 }, ''); } catch (e) {}
        // r74: Start auf der Regelhöhe für 1,78 m statt ganz unten, dann die Kamerafahrt (Auftakt).
        API.koerper(+koerperRegler.value); satzStart(); auftakt();
      } else if (st === 'ohne3d') {
        ohneDrei('Die räumliche Ansicht läuft auf diesem Gerät nicht. Maße und Shop funktionieren trotzdem.');
      } else if (st === 'ohneModell' || Date.now() - t0 > 15000) {
        ohneDrei('Das CAD-Modell ist nicht geladen. Maße und Shop funktionieren trotzdem.');
      }
      return;
    }
    if (ohne3d || t - letzte < 90) return; letzte = t;
    var z = API.zustand(), tz = NACH[z.tisch];
    if (z.hoeheMM != null) $('platte').textContent = zahl(z.hoeheMM) + ' mm';
    if (schritt === 2) {
      // Gemessen an den Plattenkörpern, sobald die Bemaßung steht; vorher die Stammdaten.
      var tt = NACH[gewaehlt], fg = z.flaecheGemessen, l = fg ? fg[0] : (z.auszug && tt.ausgezogen ? tt.ausgezogen : tt.flaeche[0]);
      $('links').textContent = zahl(l) + ' × ' + zahl(fg ? fg[1] : tt.flaeche[1]); $('links').classList.remove('krumm'); $('linksText').textContent = 'Fläche in mm';
    } else {
      var ng = $('links'); ng.textContent = Math.max(0, Math.round(z.neigung)) + '°'; ng.classList.toggle('krumm', z.neigung > NEIGUNG_ROT); $('linksText').textContent = 'Oberkörper geneigt';
    }
    $('ruwi-sp-view').setAttribute('role', 'img');
    $('ruwi-sp-view').setAttribute('aria-label', (tz ? tz.n : 'RUWI Hubtisch') + (z.hoeheMM != null ? ' auf ' + zahl(z.hoeheMM) + ' mm' : '') +
      (z.ansicht === 'hoehe' ? ', Schreiner ' + z.koerper + ' cm, Oberkörper ' + Math.max(0, Math.round(z.neigung)) + ' Grad geneigt' : ''));
  }
  texte();
  requestAnimationFrame(takt);
})();
